import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../utils/rel';
import logoUrl from './logo.jpg';
import { BreadCrumb } from './breadCrumb';
import { UserInfo } from './userInfo';
import errorBoundary from '@ifeng/errorBoundary';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';

class Header extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { headerData } = this.props;

        return (
            <div>
                <div className={styles.header}>
                    <div className={styles.logo}>
                        <a href="//www.ifeng.com/" rel={rel}>
                            <LazyImg src={logoUrl} />
                        </a>
                    </div>
                    <BreadCrumb headerData={headerData} />
                    <UserInfo />
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Header.propTypes = { headerData: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Header.defaultProps = {};

export { Header };
export default errorBoundary(Header);
